// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-wrapper {
  padding-top: var(--ant-padding);
  padding-bottom: var(--ant-padding-sm);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  z-index: 5;
  background-color: var(--ant-color-bg-container);
}
.header-right-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/header.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB","sourcesContent":[".header-wrapper {\n  padding-top: var(--ant-padding);\n  padding-bottom: var(--ant-padding-sm);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  z-index: 5;\n  background-color: var(--ant-color-bg-container);\n}\n.header-right-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
